import {ThreeTsl as TSL} from "#material/three/exports"
import type {Three as THREE} from "#material/three/exports"

// @types/three only overloads dFdx/dFdy for vec types; cast to accept floats too
export const dFdxFloat = TSL.dFdx as unknown as (x: THREE.Node<"float">) => THREE.Node<"float">
export const dFdyFloat = TSL.dFdy as unknown as (x: THREE.Node<"float">) => THREE.Node<"float">
